import * as React from 'react'
import { inputColors } from '@disco/utils/colors'
import ColorPicker from '../../../../../ui/color-input/color-picker'
type Props = {
  value: {
    color: string
  }
  onSubmit: (color: any) => unknown
}
type State = {
  color: string
}
export class Color extends React.Component<Props, State> {
  state: State = {
    color: this.props.value.color,
  }

  render(): React.ReactElement<'div'> {
    const { onSubmit, value } = this.props
    return (
      <div className="color-picker__colors-dialog">
        <ColorPicker
          onChangeComplete={color => {
            this.setState({
              color: color.hex,
            })
            onSubmit(color)
          }}
          colors={inputColors}
          color={this.state.color}
        />
      </div>
    )
  }
}
export default Color
